(function () {
  const origFocus = HTMLElement.prototype.focus;
  let pageLoadFocusHandled = false;

  // Override focus globally — intercept ANY early focus steal on page load
  HTMLElement.prototype.focus = function (options) {
    if (!pageLoadFocusHandled && this.id === "shopify-pc__banner__btn-manage-prefs") {
      pageLoadFocusHandled = true;

      // Try to redirect to the UsableNet link immediately, or wait for it
      redirectFocusToUsnet();
      return; // swallow the banner's focus call entirely
    }
    origFocus.apply(this, arguments);
  };

  function redirectFocusToUsnet() {
    const usnetLink = document.getElementById("usntA42Link");
    if (usnetLink) {
      origFocus.call(usnetLink);
    } else {
      // Element not in DOM yet — wait for it
      const observer = new MutationObserver(function () {
        const link = document.getElementById("usntA42Link");
        if (link) {
          observer.disconnect();
          origFocus.call(link);
        }
      });
      observer.observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  // Set explicit tab order once both elements exist
  function setTabOrder() {
    const usnetLink = document.getElementById("usntA42Link");
    const cookieBanner = document.getElementById("shopify-pc__banner__btn-manage-prefs");
    if (usnetLink && cookieBanner) {
      usnetLink.setAttribute("tabindex", "1");
      cookieBanner.setAttribute("tabindex", "2");
      return true;
    }
    return false;
  }

  if (!setTabOrder()) {
    const tabObserver = new MutationObserver(function () {
      if (setTabOrder()) tabObserver.disconnect();
    });
    tabObserver.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
